export default {
    tabs: {
        favorites: "Favoritos",
        fishing: "Pesca",
        slot: "Espacio",
        table: "Cuadro"
    },
    no_favorites: "todavía no hay nada aquí.<br>añade algo",
    bottom: {
        balance: ({balance}) => `$${balance}`,
        avatar: "Avatar de Perfil",
        bonus: "Bonus",
        wheel: "Xp Bar",
        settings: "Ajustes"
    }
}